module.exports = __webpack_public_path__ + "static/idowu-adc38f30bf3f621c77a577532504f036.png";